import React from 'react'

import { boxTypes } from 'routes/BoxPrices/boxPricesConfig'

import { BoxPriceSuitableForSectionProps } from './boxPriceBlockModels'

import css from './BoxPriceBlock.css'

export const BoxPriceSuitableForSection = ({ numPersons }: BoxPriceSuitableForSectionProps) => {
  const boxTypeConfig = boxTypes[numPersons]

  return (
    <React.Fragment>
      <p className={css.subhead}>{boxTypeConfig.subhead}</p>
      <ul className={css.list}>
        {boxTypeConfig.suitable.map((label) => (
          <li key={`for-${label}`} className={css.listItem}>
            {label}
          </li>
        ))}
      </ul>
    </React.Fragment>
  )
}
